<template>
    <div class="headContent">
        <div class="headTopBox">
            <div class="headTop">
                <div class="headTopLogin" @click="getMy" v-if="userDetail != '0'" style="margin-left: 28px;">我的订单</div>
                <div class="headTopLogin" @click="getLogin" v-if="userDetail == '0'">登录</div>
                <div class="headTopLogin" @click="removeLogin" v-else>退出</div>
            </div>
        </div>
        <div class="headCenterBox" v-if="!isMy">
            <div class="headCenter">
                <div class="logoBox align">
                    <el-image v-if="headData.siteimg" :src="headData.siteimg" fit="cover" class="logo"></el-image>
                    <div class="appName">{{ headData.name }}</div>
                </div>
                <div class="hcCenter">
                    <div class="hcSearchBox">
                        <!-- <el-select v-model="value" placeholder="请选择" size="large" class="hcSearch" @change="selChange">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select> -->
                        <el-input v-model="input" placeholder="请输入搜索内容" clearable class="searchIpt"></el-input>
                        <div class="hcSearchBtn" @click="hcSearchBtnTap()">搜索</div>
                    </div>
                    <div class="searchBox" v-if="headData.hotsearch && headData.hotsearch.length > 0">
                        <img src="../assets/icon/searchIcon.png" class="searchIcon">
                        <div class="searchList">
                            <div class="searchItem" v-for="(item,index) in headData.hotsearch" :key="index">{{item.title}}</div>
                        </div>
                    </div>
                </div>
                <el-image v-if="headData.invite" :src="headData.invite.img" fit="cover" class="gift" @click="headNavTap(headData.invite.url)"></el-image>
            </div>
        </div>
        <div class="headTabBox">
            <div :class="['headTab',active == index && !isMy ? 'headTabOn' : '']" v-for="(item,index) in headData.navtop" :key="index" @click="headTabTap(index,item.url)">{{item.name}}</div>
        </div>
        <el-image :src="require('@/assets/image/loginBg.png')" fit="cover" style="width:0;height:0;position: fixed;left: -100px;top: -100px;"></el-image>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                userDetail: 0,
                headData: {},
                value: '',
                options:[
                    {
                        value: '1',
                        label: 'Option1',
                    },
                    {
                        value: '2',
                        label: 'Option2',
                    },
                ],
                input: '',
                active: 0,
                isMy: false
            }
        },
        watch:{
            $route(to,from){
                if(from.path == '/login/login'){
                    this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
                }
                this.isMy = to.path == '/my/my' ? true : false
                console.log(to.path)
                console.log(this.isMy)
            }
        },
        created() {
            window.addEventListener('keydown', this.searchKey, true)//开启监听键盘按下事件
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getAppHead()
        },
        methods: {
            // 网站头数据
            getAppHead(){
                this.request.get("index/index/top",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.headData = res.data
                })
            },
            selChange(e){
                console.log(e)
            },
            // 跳转我的订单
            getMy(){
                this.$router.push({ path:'/my/my', query:{type: 'order'} })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 退出登录
            removeLogin(){
                localStorage.removeItem('userInfo')
                this.$router.go(0)
            },
            // tab切换
            headTabTap(i,e){
                this.active = i
                this.$router.push({ path:e })
            },
            // 自定义跳转
            headNavTap(e){
                if(this.userDetail == '0'){
                    this.getLogin()
                }else{
                    this.$router.push({ path:e })
                }
            },
            searchKey(e){
                if(e.keyCode === 13 && this.$route.path != '/login/login' && this.$route.path != '/my/my'){
                    this.hcSearchBtnTap()
                }
            },
            // 搜索
            hcSearchBtnTap(){
                if(this.input == ''){
                    this.$message({
                        message: '请输入您要搜索的内容',
                        type: 'warning'
                    });
                }else{
                    if(this.$route.path == '/search/search' && this.$route.query.key != this.input){
                        this.$router.push({query:{key:this.input} })
                    }
                    if(this.$route.path != '/search/search'){
                        this.$router.push({ path:'/search/search', query:{key:this.input} })
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .headContent{
        width: 100vw;
        .headTopBox{
            width: 100vw;
            height: 32px;
            background: #30353E;
            display: flex;
            align-items: center;
            justify-content: center;
            .headTop{
                width: 1200px;
                height: 32px;
                display: flex;
                flex-direction: row-reverse;
                .headTopLogin{
                    font: 14px/32px "Microsoft YaHei";
                    color: #fff;
                    cursor: pointer;
                }
            }
        }
        .headCenterBox{
            width: 100vw;
            padding: 16px 0;
            border-bottom: 1px solid #F6F7F9;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            .headCenter{
                width: 1200px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .logoBox{
                    height: 28px;
                    .logo{
                        width: 28px;
                        height: 28px;
                    }
                    .appName{
                        font: bold 20px/28px "Microsoft YaHei";
                        padding-left: 5px;
                    }                  
                }
                .headLogo{
                    width: 163px;
                    height: 28px;
                }
                .hcCenter{
                    .hcSearchBox{
                        width: 600px;
                        height: 36px;
                        display: flex;
                        align-items: center;
                        border: 1px solid #FF6A00;
                        border-radius: 4px;
                        overflow: hidden;
                        .hcSearch{
                            width: 96px;
                            font: 14px/36px "Microsoft YaHei";
                            color: #6D6D6D;
                            :deep(.el-input__wrapper) {
                                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                                cursor: default;
                                .el-input__inner {
                                    cursor: default !important;
                                }
                            }
                            /deep/ .el-select .el-input__wrapper {
                                box-shadow: none!important;
                            }
                            /deep/.el-input .el-input__wrapper.is-focus{
                                box-shadow: none!important;
                            }
                            /deep/ .el-select .el-input.is-focus .el-input__wrapper {
                                border-color: #DCDFE6  !important;
                                box-shadow: none!important;
                            }
                        }
                        .searchIpt{
                            width: 496px;
                            // height: 16px;
                            // padding: 0 10px;
                            // border-left: 1px solid #EBECEE;
                            font: 14px/16px "Microsoft YaHei";
                            color: #6D6D6D;
                            :deep(.el-input__wrapper) {
                                box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                                cursor: default;
                                .el-input__inner {
                                    cursor: default !important;
                                }
                            }
                        }
                        .hcSearchBtn{
                            flex: 1;
                            height: 36px;
                            background: #FF6A00;
                            font: 16px/36px "Microsoft YaHei";
                            color: #fff;
                            text-align: center;
                            cursor: pointer;
                        }
                    }
                    .searchBox{
                        padding-top: 8px;
                        display: flex;
                        align-items: center;
                        .searchIcon{
                            width: 51px;
                            height: 19px;
                        }
                        .searchList{
                            display: flex;
                            .searchItem{
                                font: 12px/12px "Microsoft YaHei";
                                color: #6D6D6D;
                                padding: 8px;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .gift{
                    width: 283px;
                    height: 74px;
                    cursor: pointer;
                }
            }
        }
        .headTabBox{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            .headTab{
                padding: 3px 25px;
                font: 16px/46px "Microsoft YaHei";
                color: #464646;
                cursor: pointer;
            }
            .headTabOn{
                    padding-bottom: 0;
                    border-bottom: 3px solid #FF6A00;
                    color: #FF6A00 !important;
                }
        }
    }
</style>